import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import { LoaderImg } from 'components/shared/Loader/styles'

interface UnlimitedCardSummaryItemProps {
    hasBorderBottom: boolean
}

export const UnlimitedCardSummaryItem = styled(
    Box
)<UnlimitedCardSummaryItemProps>`
    ${({ hasBorderBottom, theme }) =>
        hasBorderBottom &&
        css`
            border-bottom: 1px solid ${theme.colors.grayscale_300};
        `}

    > p:first-child {
        min-width: 100px;
        width: 100px;
        @media ${respondAbove.md} {
            min-width: 150px;
            width: 150px;
        }
    }
`

export const CardSectionImageWrapper = styled(Box)`
    position: relative;
    max-width: 221px;

    ${LoaderImg} {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 0;
        transform: translate(-50%, -50%);
    }
    & > img {
        position: relative;
        z-index: 1;
        width: 100%;
        border-radius: 10px;
    }
`
